// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_OTHER_TOPICS = "Ostatn\u00e9 f\u00f3ra";
export const FORUM_TOPICS_NOT_FOUND_query = "Nena\u0161li sa \u017eiadne f\u00f3ra so slovom \"%(query)s\".";
export const FORUM_TOPICS_SEARCH_PLACEHOLDER = "H\u013eadaj f\u00f3rum";
export const LOAD_PREVIOUS = "Na\u010d\u00edta\u0165 predch\u00e1dzaj\u00face";
